import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountClient, AccountDto, CommonClient, FileTypeEnum, ImageEnum, ObjectEnumOfGenderEnum, RoleEnum, UpdateProfileAccountRequest } from '../../shared/api-connector/sso-connector';
import { forkJoin } from 'rxjs';
import { formatDateTimeZone } from '../../shared/functions';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { UploadService } from '../../shared/services/upload.service';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { AuthService } from '../../shared/services/auth.service';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-thong-tin-ca-nhan',
  templateUrl: './thong-tin-ca-nhan.component.html',
  styleUrls: ['./thong-tin-ca-nhan.component.scss']
})
export class ThongTinCaNhanComponent implements OnInit {

  myForm = new FormGroup({
    fullNameCtrl: new FormControl('', [Validators.required]),
    emailCtrl: new FormControl(''),
    phoneNumberCtrl: new FormControl(),
    genderCtrl: new FormControl(''),
    usernameCtrl: new FormControl(),
    noteCtrl: new FormControl(''),
    birthDateCtrl: new FormControl(''),
    addressCtrl: new FormControl(''),
  });
  ctrls = this.myForm.controls;
  lstGender: ObjectEnumOfGenderEnum[] = [];
  avatarId: string = '';
  localAvatarUrl: any = null;
  isLoadingAvatar: boolean = false;
  @ViewChild('inputAvatar') $inputAvatar!: ElementRef;
  @ViewChild(MatDatepicker) birthDatePicker!: MatDatepicker<any>;
  isPickerOpened: boolean = false;
  data: AccountDto = new AccountDto();
  scrollStrategy!: ScrollStrategy;
  constructor(
    private commomClient: CommonClient,
    private accountClient: AccountClient,
    private uploadService: UploadService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    private readonly authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
    this.getDataFields();
  }
  setForm() {
    this.ctrls.fullNameCtrl.setValue(this.data.fullName);
    this.ctrls.emailCtrl.setValue(this.data.email);
    this.ctrls.phoneNumberCtrl.setValue(this.data.phoneNumber);
    this.ctrls.genderCtrl.setValue(this.data.gender);
    this.ctrls.birthDateCtrl.setValue(formatDateTimeZone(this.data.birthDate!));
    this.ctrls.addressCtrl.setValue(this.data.address);
    this.ctrls.usernameCtrl.setValue(this.data.username);
    this.ctrls.noteCtrl.setValue(this.data.note);
    this.avatarId = this.data.avatarId || '';
  }
  onChangeFileAvatar(event: any) {
    const file = event.target.files[0];
    this.$inputAvatar.nativeElement.value = '';
    if (file) {
      // 1. Preview Local Image immediately
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.localAvatarUrl = e.target.result;
      };
      reader.readAsDataURL(file);

      // 2. Upload to Server
      this.isLoadingAvatar = true;
      this.uploadService.uploadFile(file, FileTypeEnum.AvatarAccount, ImageEnum.AvatarType)
        .pipe(finalize(() => this.isLoadingAvatar = false))
        .subscribe((x: any) => {
          if (x.isSuccess) {
            this.avatarId = x.id;
            // Keep localAvatarUrl to avoid flickering while server image loads
            // this.localAvatarUrl = null; 

            // Optionally update the header avatar immediately via AuthService or similar if needed
            // But here we just update the form's local state.
          } else {
            this.alertService.error("File upload không đúng định dạng", "Lỗi upload file");
            this.localAvatarUrl = null; // Revert if failed
          }
        });
    }
  }
  getDataFields() {
    forkJoin([this.commomClient.getListGender(), this.accountClient.getProfile()])
      .subscribe(x => {
        this.lstGender = x[0] || [] as any;
        if (this.lstGender && this.lstGender.length > 0) {
          const firstItem: any = this.lstGender[0];
          const val = firstItem.Value !== undefined ? firstItem.Value : firstItem.value;
          this.ctrls.genderCtrl.setValue(val);
        }
        this.data = x[1] || new AccountDto();
        this.setForm();
        this.cdr.detectChanges();
      });
  }
  getRoleId(id: RoleEnum) {
    return `role_edit_${id}`;
  }
  getUrlFile(id: string) {
    return this.uploadService.getUrlFile(id);
  }

  openBirthDatePicker(picker: any) {
    console.log('BirthDatePicker Source:', picker);
    if (picker) {
      picker.open();
    } else {
      console.error('Picker parameter is missing!');
    }
  }

  @Output()
  onReloadAvatar = new EventEmitter();

  isSaving = false;

  onSubmit() {
    if (this.myForm.valid && !this.isSaving) {
      this.isSaving = true;
      let birthDate = this.ctrls.birthDateCtrl.value;
      if (birthDate && typeof birthDate === 'string') {
        birthDate = new Date(birthDate);
      } else if (birthDate && birthDate._isAMomentObject) {
        birthDate = birthDate.toDate();
      }

      this.accountClient.updateProfile(new UpdateProfileAccountRequest({
        address: this.ctrls.addressCtrl.value,
        avatarId: this.avatarId,
        birthDate: birthDate,
        fullName: this.ctrls.fullNameCtrl.value,
        gender: this.ctrls.genderCtrl.value,
        note: this.ctrls.noteCtrl.value,
      }))
        .pipe(finalize(() => this.isSaving = false))
        .subscribe({
          next: (x) => {
            this.alertService.success('Cập nhật thông tin cá nhân thành công', 'Cập nhật thông tin cá nhân');
            if (x) {
              this.authService.setAvatarId(x);
            }
          },
          error: (err) => {
            this.alertService.error('Có lỗi xảy ra khi cập nhật thông tin', 'Lỗi');
            console.error('Update profile error:', err);
          }
        });
    }
  }
  onReset() {
    this.myForm.reset();
    setTimeout(() => {
      this.setForm();
    }, 300);
  }
  openDialogChangePassword() {
    this.dialog.open(ChangePasswordComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategyOptions.noop()
    });
  }
}
